import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Dashboard from "../container/Dashboard/Dashboard";
import SideMenu from "../components/SideMenu/SideMenu";
import Header from "../components/Header/Header";
import UserProfile from "../container/UserProfile/UserProfile";
import LogoutPopup from "../components/LogoutPopup/LogoutPopup";
import Farmers from "../container/Farmer/Farmer";
import TaskAssignMent from "../container/TaskAssignment/TaskAssignment";
import ReportSubmission from "../container/ReportSubmission/ReportSubmission";
import DataCollector from "../container/DataCollector/DataCollector";
import DataCollectorDetail from "../container/DataCollector/DataCollectoreDetail";
import Region from "../container/Region/Region";
import UserManagement from "../container/UserManagement/UserManagement";
import UserManagementDetail from "../container/UserManagement/UserManagementDetail";
import Crops from "../container/TypeOfCrops/TypeOfCrops";
import CropsData from "../container/TypeOfCrops/Crops";
import Machinery from "../container/TypesOfMachinery/TypesOfMachinery";
import MachineryData from "../container/TypesOfMachinery/Machinery";
import { logout } from "../config/services";
import { useDispatch, useSelector } from "react-redux";
import { setUserLogin } from "../container/Login/slice/userLoginSlice";
import { clearUserDetails } from "../container/Login/slice/userSlice";
import Livestock from "../container/TypesOfLiveStock/TypesOfLiveStock";
import LivestockData from "../container/TypesOfLiveStock/Livestock";
import PiscicultureData from "../container/TypesOfPisciculture/Pisciculture";
import Pisciculture from "../container/TypesOfPisciculture/TypesOfPisciculture";

import CertificationData from "../container/CertificationTraining/Certification";
import TaskDetail from "../container/TaskAssignment/TaskDetail";
import TrainingProgram from "../container/TrainingProgram/TypesOfProgram";
import TraningProgramData from "../container/TrainingProgram/TraningProgram";
import SponsoredData from "../container/WhoSponsered/WhoSponsered";
import ForgotPassword from "../container/Login/ForgotPassword/ForgotPassword";
import ChangePasswordPopup from "../components/ChangePasswordPopup/ChangePasswordPopup";

const AuthenticationRoutes = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    // Get the initial state from localStorage
    const savedState = localStorage.getItem('isSidebarOpen');
    return savedState !== null ? JSON.parse(savedState) : true; // Default to false if not found
  });

  const [isLogoutOpen, setIsLogoutOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(
    localStorage.getItem("selectedIndex") || "Dashboard"
  );

  useEffect(() => {
    localStorage.setItem("selectedIndex", selectedIndex);
  }, [selectedIndex]);


  useEffect(() => {
    // Save the state to localStorage whenever it changes
    localStorage.setItem('isSidebarOpen', JSON.stringify(isSidebarOpen));
  }, [isSidebarOpen]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { email, token, id} = useSelector((state) => state.userState);
  const [loading, setIsLoading] = useState(false);
  const [changePassword, setChangePassword] = useState(false);

  const handleLogout = async () => {
    const params = {
      token: token,
    };

    try {
      setIsLoading(true);
      const resp = await logout(params);
      if (resp.status === 200 || resp.status === 201) {
        setIsLoading(false);
        dispatch(setUserLogin({ userName: null }));
        dispatch(clearUserDetails());
        navigate("/");
        window.location.reload(false);
        localStorage.clear();
      } else {
        console.error("Logout failed with status:", resp.status);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error occurred during logout:", error);
      setIsLoading(false);
    }
  };


  return (
    <>
      <Header
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
        isLogoutOpen={isLogoutOpen}
        setIsLogoutOpen={setIsLogoutOpen}
        setChangePassword={setChangePassword}
        changePassword={changePassword}
      />

      <div className="d-flex" style={{ paddingTop: "130px" }}>
        {/* Side Menu */}
        <SideMenu
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          isLogoutOpen={isLogoutOpen}
          changePassword={changePassword}
        />

        {/* Main Content */}
        <div
          className="main-content"
          style={{
            width: "100%",
            padding: "0px 20px",
            position: "fixed",
            paddingLeft: isSidebarOpen ? "289px" : "123px",
            height: "100vh",
            overflow: "auto",

          }}
        >
          <Routes>
            <Route path="/dashboard" element={<Dashboard isSidebarOpen={isSidebarOpen} />} />
            <Route path="/user-profile" element={<UserProfile />} />
            <Route path="/farmer" element={<Farmers />} />
            <Route path="/task-assignment" element={<TaskAssignMent />} />
            <Route path="/task-assignment/:id" element={<TaskDetail />} />
            <Route path="/report-submission" element={<ReportSubmission />} />
            <Route path="/collectors-list" element={<DataCollector />} />
            <Route
              path="/collectorlist-detail/:id"
              element={<DataCollectorDetail />}
            />
            <Route path="/region-locality" element={<Region />} />
            <Route path="/user-management" element={<UserManagement />} />
            <Route
              path="/user-management-detail"
              element={<UserManagementDetail />}
            />
            <Route path="/crops" element={<Crops />} />
            <Route path="/crops-data/:id" element={<CropsData />} />
            <Route path="/livestock" element={<Livestock />} />
            <Route path="/livestock-data/:id" element={<LivestockData />} />
            <Route path="/training-program" element={<TrainingProgram />} />
            <Route
              path="/trainig-program-data/:id"
              element={<TraningProgramData />}
            />
            <Route path="/sponsored" element={<SponsoredData />} />
            <Route path="/certification" element={<CertificationData />} />

            <Route path="/pisciculture" element={<Pisciculture />} />
            <Route
              path="/pisciculture-data/:id"
              element={<PiscicultureData />}
            />
            <Route path="/pisciculture" element={<Pisciculture />} />
            <Route
              path="/pisciculture-data/:id"
              element={<PiscicultureData />}
            />
            <Route path="/machinery" element={<Machinery />} />
            <Route path="/machinery-data/:id" element={<MachineryData />} />
          </Routes>

          <LogoutPopup
            isOpen={isLogoutOpen}
            onClose={() => setIsLogoutOpen(false)}
            onConfirm={() => handleLogout()}
            loading={loading}
          />
          <ChangePasswordPopup
            isOpen={changePassword}
            onClose={() => setChangePassword(false)}
            onConfirm={() => handleLogout()}
            loading={loading}
            setLoading={setIsLoading}
            id={id}
          />

        </div>
      </div>
    </>
  );
};

export default AuthenticationRoutes;
